var _desc, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: "48px",
    height: "48px",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId,
    stroke: "#2329D6",
    strokeWidth: 1,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    fill: "none",
    color: "#2329D6",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "gridLargeIconTitle"
  }, "Large Grid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "gridLargeIconTitle"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "gridLargeIconDesc"
  }, "Icon of a large 2-by-2 grid")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    x: 3,
    y: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    x: 14,
    y: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    x: 3,
    y: 14
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    x: 14,
    y: 14
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.0ed46e314b875f36711dc7f1d0236e4f.svg";
export { ForwardRef as ReactComponent };